'use client';

import { usePathname } from 'next/navigation';
import { OnboardingPopup, useOnboarding } from '@/app/user-and-session/new-user-onboarding';

/**
 * Global onboarding component that appears on every page when needed
 * This component handles the global onboarding flow for new users
 * Excludes blog pages from mandatory onboarding
 */
export function GlobalOnboarding() {
  const pathname = usePathname();
  const { showOnboarding, handleOnboardingComplete, defaultPreferredName } = useOnboarding();

  // Skip onboarding for blog pages      // blogs
  const isTOS = pathname.startsWith('/terms-of-service');
  const isPrivacy = pathname.startsWith('/privacy');
  const isCommunityGuidelines = pathname.startsWith('/community-guidelines');
  const isAboutUs = pathname.startsWith('/about-us');
  const isBlogPage = isTOS || isPrivacy || isCommunityGuidelines || isAboutUs;
  
  // Don't show onboarding on blog pages
  const shouldShowOnboarding = showOnboarding && !isBlogPage;

  return (
    <OnboardingPopup
      isOpen={shouldShowOnboarding}
      onComplete={handleOnboardingComplete}
      defaultPreferredName={defaultPreferredName}
    />
  );
}
